var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commercial-content"},[_c('div',{staticClass:"commercial-item"},_vm._l((_vm.ads),function(ad,idx){return _c('a',{key:idx,staticClass:"ad-container",class:Object.keys(_vm.ads).length > 1 ? 'ad-container-gap' : '',style:({
        backgroundImage: ("url('" + (_vm.$common.resSrc(ad[0].photo)) + "')"),
        height: (_vm.adHeight + "px"),
      }),attrs:{"href":ad[0].href},on:{"click":function($event){return _vm.sendVisit(ad[0].id)}}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }